import HeaderSection from '../components/HeaderSection/HeaderSection'
import Line from '../components/Line/Line'


const reckewegOptions = [
  'Goteros',
  'Jarabes, aceites, y soluciones tópicas',
  'Cápsulas',
  'Solución estéril con nebulizador nasal',
  'Procaína Kholer 2%',
  'Inyectables',
]

const tegorOptions = [
  'Depuración',
  'Control de peso',
  'Celulitis y piernas',
  'Tránsito y digestión',
  'Para la mujer',
  'Para hombres'
]

const helixorOptions = [
  'Helixor A',
  'Helixor M',
  'Helixor P'
]

const symbioOptions = [
  'Symbioflor® 1',
  'Symbioflor® 2',
  'SymbioLact® COMP',
  'SymbioINTEST®'
]

const regenhialOptions = [
  'Regenhial',
  'Regenhial INTIM',
  'Regenhial Concentrates',
  'Regenhial Oral'
]

const Lines = () => {
  return (
    <div>
      <HeaderSection title={'Líneas Eupha'} subtitle={'Nuestras Líneas'} />
      <Line brand={'reckeweg'} title={'Homeopatía'} options={reckewegOptions}/>
      <Line brand={'tegor'} title={'Fitoterapia'} options={tegorOptions} />
      <Line brand={'helixor'} title={'Terapia Oncológica'} options={helixorOptions} />
      <Line brand={'symbio'} title={'Terapia Microbiológica'} options={symbioOptions} />
      <Line brand={'regenhial'} title={'Dermocosmética'} options={regenhialOptions} />
    </div>
  );
}

export default Lines;